import { Link } from 'react-router-dom';
import { Card, CardBody, CardHeader, CardTitle } from '../components/ui/Card.js';

const QUICK_LINKS = [
  { to: '/ninas', label: 'Niñas', description: 'Padrón distrital + alta + edición' },
  { to: '/actividades', label: 'Actividades', description: 'Captura de actividades trimestrales' },
  { to: '/adelantos', label: 'Adelantos', description: 'Registro de adelantos por niña' },
  {
    to: '/capacitaciones',
    label: 'Capacitaciones',
    description: 'Registro de capacitaciones del staff',
  },
  { to: '/dashboard', label: 'Dashboard', description: 'Reportes trimestrales agregados' },
  { to: '/admin', label: 'Admin', description: 'Catálogos + audit log (solo administradoras)' },
] as const;

export function Home() {
  return (
    <div className="flex flex-col gap-6">
      <Card>
        <CardHeader>
          <CardTitle>SISREP Distrital</CardTitle>
        </CardHeader>
        <CardBody>
          <p>
            Sistema de captura, consulta y reportería trimestral para el Distrito Guías de México
            (Monterrey Cumbres). Reemplaza el flujo manual de Word/Excel con una experiencia
            digital, offline-first y privacy-aware.
          </p>
        </CardBody>
      </Card>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {QUICK_LINKS.map((link) => (
          <Link
            key={link.to}
            to={link.to}
            className="block bg-white rounded-lg shadow-sm border border-gray-200 p-5 hover:border-distrito-300 hover:shadow-md transition"
          >
            <div className="font-semibold text-distrito-700">{link.label}</div>
            <div className="text-sm text-gray-600 mt-1">{link.description}</div>
          </Link>
        ))}
      </div>
    </div>
  );
}
